export const NAVBAR_CLASS = "__navbar";
export const CHAT_HEADER_CLASS = "__header";
export const CHAT_MESSAGE_CLASS = "__chat";
export const MAX_TRIBE_USERS = 6;
export const LAST_SELECTED_TRIBE_KEY = "lastSelectedTribeId";
